import { createContext, useContext, useMemo } from 'react';
import { AttributeReferenceConfig } from 'pages/Financials/financials-widget-drawer/types';
import WidgetDrawer from '../../../components/Drawer/widget-drawer/WidgetDrawer';
import WidgetDrawerProps from '../../../components/Drawer/widget-drawer/WidgetDrawer.props';
import { useDocumentFootnotes } from '../../../context/DocumentFootnotesContext';
import {
  ClearAttributeMappingsPayload,
  DocumentModificationPayload,
} from '../../../services/sheet-attribute-manager/models/sheet-attribute-manager.interface';
import SheetAttributeManager from '../../../services/sheet-attribute-manager/SheetAttributeManager';

export interface HandlePushingAttributeMappingsPayload {
  showNotification?: boolean;
  documentReferencePayload?: DocumentModificationPayload;
  selectedCell?: any;
}

const AttributeMappedWidgetDrawerContext = createContext<{
  attributeMapper?: SheetAttributeManager;
  attributeReferenceConfig?: AttributeReferenceConfig;
  handlePushingAttributeMappings?: (payload?: HandlePushingAttributeMappingsPayload) => void;
  handleClearMappings?: (docRefPayload?: ClearAttributeMappingsPayload) => void;
    }>({});

export const useAttributeMappedWidgetDrawer = () => useContext(AttributeMappedWidgetDrawerContext);

export interface AttributeMappedWidgetDrawerProps extends WidgetDrawerProps {
  attributeMapper?: SheetAttributeManager;
  attributeReferenceConfig: AttributeReferenceConfig;
  handlePushingAttributeMappings?: (payload?: HandlePushingAttributeMappingsPayload) => void;
  handleClearMappings?: (docRefPayload?: ClearAttributeMappingsPayload) => void;
}

export const AttributeMappedWidgetDrawer = (props: AttributeMappedWidgetDrawerProps) => {
  const { footnotes, documentSourceMap } = useDocumentFootnotes();

  const documentSourceProps = useMemo(
    () => ({
      documentCitations: footnotes,
      documentMetadata: documentSourceMap,
    }),
    [footnotes, documentSourceMap]
  );

  return (
    <AttributeMappedWidgetDrawerContext.Provider
      value={{
        attributeMapper: props.attributeMapper,
        attributeReferenceConfig: props.attributeReferenceConfig,
        handlePushingAttributeMappings: props.handlePushingAttributeMappings,
        handleClearMappings: props.handleClearMappings,
      }}>
      <WidgetDrawer
        applicationContext={props.applicationContext}
        documentReferencesProps={props.documentReferencesProps}
        documentSourceProps={documentSourceProps}
        notesProps={props.notesProps}
        spreadsheetNotesProps={props.spreadsheetNotesProps}
        documentTabCustomActions={props.documentTabCustomActions}
        documentApplicationStorageKey={props.documentApplicationStorageKey}
      />
    </AttributeMappedWidgetDrawerContext.Provider>
  );
};
